import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Snackbar,
  Alert,
  Tabs,
  Tab,
  Paper,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme, useMediaQuery,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";

const RegistroServiciosTipoServicios = () => {
  const [tab, setTab] = useState(0);
  const isMobile = useMediaQuery(useTheme().breakpoints.down("sm"));

  // Estado general
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false); // Estado para abrir/ cerrar el modal de eliminación
  const [alertMessage, setAlertMessage] = useState(""); // Mensaje de alerta
  const [alertOpen, setAlertOpen] = useState(false); // Estado para abrir/ cerrar la alerta
  const [alertSeverity, setAlertSeverity] = useState("success"); // Severidad de la alerta (success, error)

  // Estado de eliminación
  const [currentDeleteId, setCurrentDeleteId] = useState(null);
  const [currentDeleteCollection, setCurrentDeleteCollection] = useState("");
  const [currentDeleteLabel, setCurrentDeleteLabel] = useState("");


  // Tipo Servicios
  const [tipoServiciosList, setTipoServiciosList] = useState([]);
  const [formDatatipoServicios, setFormDatatipoServicios] = useState({ nombre: "", descripcion: "", abreviatura: "" });
  const [showFormTipo, setShowFormTipo] = useState(false);
  const [editingTipoId, setEditingTipoId] = useState(null);

  // Servicios
  const [formDataServicio, setFormDataServicio] = useState({ nombre: "", descripcion: "", id_tipoServicios: "", precio: "" });
  const [serviciosList, setServiciosList] = useState([]);
  const [showFormServicio, setShowFormServicio] = useState(false);
  const [editingServicioId, setEditingServicioId] = useState(null);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = async () => {
    const tiposSnapshot = await getDocs(collection(db, "tipoServicios"));
    setTipoServiciosList(tiposSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));

    const serviciosSnapshot = await getDocs(collection(db, "servicios"));
    setServiciosList(serviciosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  };

  // const handleAlert = (message, severity) => {
  //   setAlertInfo({ message, severity });
  //   setOpenAlert(true);
  // };

  const handleAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleSubmitTipo = async (e) => {
    e.preventDefault();
    try {
      if (editingTipoId) {
        // Actualizar tipo de servicio
        await updateDoc(doc(db, "tipoServicios", editingTipoId), formDatatipoServicios);
        setAlertMessage("Tipo de servicio actualizado exitosamente.");
        setAlertSeverity("success");
      } else {
        // Agregar nuevo tipo de servicio
        await addDoc(collection(db, "tipoServicios"), formDatatipoServicios);
        setAlertMessage("Nuevo tipo de servicio agregado exitosamente.");
        setAlertSeverity("success");
      }

      setFormDatatipoServicios({ nombre: "", descripcion: "", abreviatura: "" });
      setEditingTipoId(null);
      setShowFormTipo(false);
      setAlertOpen(true); // Mostrar alerta
      getAllData();
    } catch (error) {
      console.error("Error al guardar tipo de servicio:", error);
      setAlertMessage("Ocurrió un error. Intenta nuevamente.");
      setAlertSeverity("error");
      setAlertOpen(true); // Mostrar alerta
    }
  };


  const handleSubmitServicio = async (e) => {
    e.preventDefault();
    try {
      if (editingServicioId) {
        // Actualizar servicio
        await updateDoc(doc(db, "servicios", editingServicioId), formDataServicio);
        setAlertMessage("Servicio actualizado exitosamente.");
        setAlertSeverity("success");
      } else {
        // Agregar nuevo servicio
        await addDoc(collection(db, "servicios"), formDataServicio);
        setAlertMessage("Nuevo servicio agregado exitosamente.");
        setAlertSeverity("success");
      }

      setFormDataServicio({ nombre: "", descripcion: "", id_tipoServicios: "", precio: "" });
      setEditingServicioId(null);
      setShowFormServicio(false);
      setAlertOpen(true); // Mostrar alerta
      getAllData();
    } catch (error) {
      console.error("Error al guardar servicio:", error);
      setAlertMessage("Ocurrió un error. Intenta nuevamente.");
      setAlertSeverity("error");
      setAlertOpen(true); // Mostrar alerta
    }
  };

  const handleDelete = async (id, collectionName) => {
    await deleteDoc(doc(db, collectionName, id));
    getAllData();
    handleAlert("Eliminado correctamente", "success");
  };

  const handleOpenDeleteDialog = (id, collectionName, label) => {
    setCurrentDeleteId(id);
    setCurrentDeleteCollection(collectionName);
    setCurrentDeleteLabel(label);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setCurrentDeleteId(null);
    setCurrentDeleteCollection("");
    setCurrentDeleteLabel("");
  };

  const handleConfirmDelete = async () => {
    if (currentDeleteId && currentDeleteCollection) {
      await handleDelete(currentDeleteId, currentDeleteCollection);
      handleCloseDeleteDialog();
    }
  };


  return (
    // Dentro del return, reemplaza todo lo que sigue después de <Container> por esto:
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1A3E5D", marginBottom: 2 }}>
        Gestión de Tipos de Servicio y Servicios
      </Typography>

      <Tabs value={tab} onChange={(e, newVal) => setTab(newVal)} sx={{ mb: 3 }}>
        <Tab label="Tipos de Servicio" />
        <Tab label="Servicios" />
      </Tabs>

      {tab === 0 && (
        showFormTipo ? (
          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1A3E5D" }}>
                {editingTipoId ? "Editar Tipo de Servicio" : "Nuevo Tipo de Servicio"}
              </Typography>
              <IconButton onClick={() => setShowFormTipo(false)} color="#01579b">
                <CloseIcon />
              </IconButton>
            </Box>

            <form onSubmit={handleSubmitTipo}>
              <TextField
                fullWidth label="Nombre" margin="normal"
                value={formDatatipoServicios.nombre}
                onChange={(e) => setFormDatatipoServicios({ ...formDatatipoServicios, nombre: e.target.value })}
              />
              <TextField
                fullWidth label="Descripción" margin="normal"
                value={formDatatipoServicios.descripcion}
                onChange={(e) => setFormDatatipoServicios({ ...formDatatipoServicios, descripcion: e.target.value })}
              />
              <TextField
                fullWidth label="Abreviatura" margin="normal"
                value={formDatatipoServicios.abreviatura}
                onChange={(e) => setFormDatatipoServicios({ ...formDatatipoServicios, abreviatura: e.target.value })}
                sx={{
                  '& .MuiInputBase-input': {
                    textTransform: 'uppercase',
                  },
                }} 
              />

              <Box sx={{ marginTop: 2 }}>
                <Button type="submit" variant="contained" fullWidth sx={{ backgroundColor: "#01579b", color: "white", '&:hover': { backgroundColor: "#014377" } }}>
                  {editingTipoId ? "Actualizar Tipo de Servicio" : "Guardar Tipo de Servicio"}
                </Button>
              </Box>
            </form>
          </Box>
        ) : (
          <>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddCircleIcon />}
              onClick={() => setShowFormTipo(true)}
              sx={{ marginBottom: 2 }}
            >
              Agregar Tipo de Servicio
            </Button>
            {isMobile ? (
              <Box>
                {tipoServiciosList.map((tipo) => (
                  <Card key={tipo.id} sx={{ marginBottom: 2, padding: 2 }}>
                    <CardContent>
                      <Typography><strong>Nombre:</strong> {tipo.nombre}</Typography>
                      <Typography><strong>Descripción:</strong> {tipo.descripcion}</Typography>
                      <Typography><strong>Abreviatura:</strong> {tipo.abreviatura}</Typography>
                      <Box mt={1}>
                        <IconButton color="primary" onClick={() => {
                          setFormDatatipoServicios(tipo);
                          setEditingTipoId(tipo.id);
                          setShowFormTipo(true);
                        }}>
                          <Edit />
                        </IconButton>
                        <IconButton color="secondary" onClick={() => handleDelete(tipo.id, "tipoServicios")}>
                          <Delete />
                        </IconButton>
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            ) : (
              <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                      <TableCell>Descripción</TableCell>
                      <TableCell>Abreviatura</TableCell>
                      <TableCell>Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tipoServiciosList.map((tipo) => (
                      <TableRow key={tipo.id}>
                        <TableCell>{tipo.nombre}</TableCell>
                        <TableCell>{tipo.descripcion}</TableCell>
                        <TableCell>{tipo.abreviatura}</TableCell>
                        <TableCell>
                          <IconButton color="primary" onClick={() => {
                            setFormDatatipoServicios(tipo);
                            setEditingTipoId(tipo.id);
                            setShowFormTipo(true);
                          }}>
                            <Edit />
                          </IconButton>
                          <IconButton color="secondary" onClick={() => handleOpenDeleteDialog(tipo.id, "tipoServicios", "Tipo de Servicio")}>
                            <Delete />
                          </IconButton>

                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )
      )}

      {tab === 1 && (
        showFormServicio ? (
          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1A3E5D" }}>
                {editingServicioId ? "Editar Servicio" : "Nuevo Servicio"}
              </Typography>
              <IconButton onClick={() => setShowFormServicio(false)} color="#01579b">
                <CloseIcon />
              </IconButton>
            </Box>

            <form onSubmit={handleSubmitServicio}>
              <TextField
                fullWidth label="Nombre" margin="normal"
                value={formDataServicio.nombre}
                onChange={(e) => setFormDataServicio({ ...formDataServicio, nombre: e.target.value })}
              />
              <TextField
                fullWidth label="Descripción" margin="normal"
                value={formDataServicio.descripcion}
                onChange={(e) => setFormDataServicio({ ...formDataServicio, descripcion: e.target.value })}
              />
              <FormControl fullWidth margin="normal">
                <InputLabel>Tipo de Servicio</InputLabel>
                <Select
                  value={formDataServicio.id_tipoServicios}
                  onChange={(e) => setFormDataServicio({ ...formDataServicio, id_tipoServicios: e.target.value })}
                >
                  {tipoServiciosList.map((tipo) => (
                    <MenuItem key={tipo.id} value={tipo.id}>
                      {tipo.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                fullWidth label="Precio" margin="normal" type="number"
                value={formDataServicio.precio}
                onChange={(e) => setFormDataServicio({ ...formDataServicio, precio: e.target.value })}
              />

              <Box sx={{ marginTop: 2 }}>
                <Button type="submit" variant="contained" fullWidth sx={{ backgroundColor: "#01579b", color: "white", '&:hover': { backgroundColor: "#014377" } }}>
                  {editingServicioId ? "Actualizar Servicio" : "Guardar Servicio"}
                </Button>
              </Box>
            </form>
          </Box>
        ) : (
          <>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddCircleIcon />}
              onClick={() => setShowFormServicio(true)}
              sx={{ marginBottom: 2 }}
            >
              Agregar Servicio
            </Button>
            {isMobile ? (
              <Box>
                {serviciosList.map((serv) => (
                  <Card key={serv.id} sx={{ marginBottom: 2, padding: 2 }}>
                    <CardContent>
                      <Typography><strong>Nombre:</strong> {serv.nombre}</Typography>
                      <Typography><strong>Descripción:</strong> {serv.descripcion}</Typography>
                      <Typography><strong>Tipo:</strong>  {tipoServiciosList.find((tipo) => tipo.id === serv.id_tipoServicios)?.nombre || 'Sin tipo'}</Typography>
                      <Typography><strong>Precio:</strong> ${serv.precio}</Typography>
                      <Box mt={1}>
                        <IconButton color="primary" onClick={() => {
                          setFormDataServicio(serv);
                          setEditingServicioId(serv.id);
                          setShowFormServicio(true);
                        }}>
                          <Edit />
                        </IconButton>
                        <IconButton color="secondary" onClick={() => handleDelete(serv.id, "servicios")}>
                          <Delete />
                        </IconButton>
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            ) : (
              <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                      <TableCell>Descripción</TableCell>
                      <TableCell>Tipo de Servicio</TableCell>
                      <TableCell>Precio</TableCell>
                      <TableCell>Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {serviciosList.map((serv) => (
                      <TableRow key={serv.id}>
                        <TableCell>{serv.nombre}</TableCell>
                        <TableCell>{serv.descripcion}</TableCell>
                        <TableCell>
                          {tipoServiciosList.find((tipo) => tipo.id === serv.id_tipoServicios)?.nombre || 'Sin tipo'}
                        </TableCell>
                        <TableCell>${serv.precio}</TableCell>
                        <TableCell>
                          <IconButton color="primary" onClick={() => {
                            setFormDataServicio(serv);
                            setEditingServicioId(serv.id);
                            setShowFormServicio(true);
                          }}>
                            <Edit />
                          </IconButton>
                          <IconButton color="secondary" onClick={() => handleOpenDeleteDialog(serv.id, "servicios", "Servicio")}>
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )
      )}

      {/* Alerta */}
      <Snackbar open={alertOpen} autoHideDuration={6000} onClose={() => setAlertOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      {/* Modal de Confirmación de Eliminación */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirmación</DialogTitle>
        <DialogContent>
          <Typography>¿Estás seguro de eliminar este {currentDeleteLabel.toLowerCase()}?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default RegistroServiciosTipoServicios;
